module.exports = __webpack_public_path__ + "static/media/icon_altacontratante.ac10ada7.svg";